import { useState } from "react";
import Helmet from "react-helmet";
import ReactMarkdown from "react-markdown";
import { useParams } from "react-router-dom";
import styled from "@emotion/styled";
import { useGetMeQuery, useGetGameQuery } from "generated/graphql";
import SideBar from "components/sidebar/Sidebar";
import NavBar from "components/navbar/NavBar";

const IndividualGamePageWrapper = styled.div`

  /* Side Navbar */

  .sponsor {
    width: 100;
    height: 30px;
    margin-top: 0px;
    margin-left: -5px;
  }

  .sidebar {
    width: 200px;
    height: 100%;
    background: #701129;
    padding: 30px 0px;
    position: fixed;
  }

  .side-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
    margin-left: 50px;
    margin-top: -20px;
  }

  .search {
    width: 170px;
    height: 35px;
    margin-left: 15px;
  }

  .sidebar ul {
    list-style-type: none;
    margin-top: -10px;
  }

  .sidebar ul li {
    padding: 15px;
  }

  .sidebar ul li a {
    color: #ffffff;
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    margin-right: 35px;
  }

  /* Top Navbar */

  .profilePic img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  /* Profile Info */

  .profile_cover_photo {
    position: relative;
    width: 100%;
    margin-top: -20px;
  }

  .game_info_pic img {
    position: absolute;
    top: 150px;
    left: 250px;
    width: 170px;
    height: 230px;
    border-radius: 5px;
  }

  .container2 {
    display: block;
    margin-top: 20px;
    margin-left: 200px;
    height: 320px;
  }

  .profile_trophies {
    position: absolute;
    top: 110px;
    left: 20px;
    font-weight: bold;
    font-size: larger;
    margin-left: 370px;
  }

  .profile_trophies img {
    width: 35px;
    height: 35px;
    margin-top: 10px;
  }

  .ph1 {
    position: absolute;
    margin-left: 240px;
    margin-top: -55px;
    font-size: 40px;
    font-weight: bolder;
  }

  /* Floating Navbar */

  .game_float_navbar {
    position: relative;
    overflow: hidden;
    background-color: #1d2029;
    margin-left: 440px;
    margin-right: 150px;
    height: 40px;
    border-radius: 50px;
    margin-top: -40px;
  }

  .game_float_links button {
    float: none;
    display: inline-block;
    position: relative;
    top: 50%;
    left: 5%;
    top: 12px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
    outline: none;
    border: 0;
    background: none;
  }

  .game_float_links2 button {
    float: none;
    display: inline-block;
    position: relative;
    top: 50%;
    left: 45%;
    top: -15px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
    outline: none;
    border: 0;
    background: none;
  }

  .game_float_links3 button {
    float: none;
    display: inline-block;
    position: relative;
    top: 50%;
    left: 83%;
    top: -40px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
    outline: none;
    border: 0;
    background: none;
  }

  button {
    cursor: pointer;
  }

  button.active {
    color: #fff;
    font-weight: bold;
  }

  /* Rules Section */

  #rules_section {
    width: 60%;
    margin-left: 450px;
    margin-top: 50px;
  }

  /* Teams Section */

  #teams_section {
    display: none;
    width: 60%;
    margin-left: 450px;
    margin-top: 50px;
  }

  /* Schedule Section */

  #schedule_section {
    display: none;
    margin-left: 150px;
    margin-top: 50px;
    padding-bottom: 20px;
  }

  .month {
    padding: 70px 25px;
    width: 70%;
    background: #701129;
    text-align: center;
    margin-left: 250px;
  }

  ul {
    list-style-type: none;
  }

  .month ul {
    margin: 0;
    padding: 0;
  }

  .month ul li {
    color: white;
    font-size: 20px;
    text-transform: uppercase;
    letter-spacing: 3px;
  }

  .month .prev {
    float: left;
    padding-top: 10px;
  }

  .month .next {
    float: right;
    padding-top: 10px;
  }

  .weekdays {
    margin: 0;
    padding: 10px 0;
    background-color: #777;
    width: 74%;
    margin-left: 250px;
  }

  .weekdays li {
    display: inline-block;
    width: 13.6%;
    color: #fff;
    text-align: center;
  }

  .days {
    padding: 10px 0;
    background: #1d2029;
    margin: 0;
    width: 74%;
    margin-left: 250px;
  }

  .days li {
    list-style-type: none;
    display: inline-block;
    width: 13.6%;
    text-align: center;
    margin-bottom: 5px;
    font-size: 15px;
    color: #ffffff;
  }

  .days li .active {
    padding: 5px;
    background: #701129;
    color: white !important;
  }
`;

function IndividualGamePage() {
  const [activeSection, setActiveSection] = useState("rules");
  // @ts-ignore
  const { gameId } = useParams();
  const { data: me, loading: loadingMe } = useGetMeQuery();
  const { data: game, loading: loadingGame } = useGetGameQuery({
    variables: { gameId },
  });
  return (
    <IndividualGamePageWrapper>
      <Helmet>
        {game && <title>{game?.game?.name} — Jiwe eSports</title>}
      </Helmet>
      <SideBar nickname={me?.me?.nickname} isLoggedIn={!!me?.me?.nickname} />
      {!loadingMe && me && (
        <NavBar nickname={me?.me?.nickname} name={me?.me?.name} />
      )}

      {!loadingGame && game && (
        <>
          <div className="container2">
            <div className="profile_parent">
              <img
                className="profile_cover_photo"
                src={game?.game?.banner_url!}
                alt=""
              />
              <p className="ph1">{game?.game?.name}</p>
              <div className="game_info_pic">
                <img src={game?.game?.poster_url!} alt="" />
              </div>
            </div>
          </div>

          <div className="game_float_navbar">
            <div className="game_float_links">
              <button
                onClick={() => setActiveSection("rules")}
                className={activeSection === "rules" ? "active" : ""}
              >
                RULES
              </button>
            </div>
            <div className="game_float_links2">
              <button
                onClick={() => setActiveSection("teams")}
                className={activeSection === "teams" ? "active" : ""}
              >
                TEAMS
              </button>
            </div>
            <div className="game_float_links3">
              <button
                onClick={() => setActiveSection("scheule")}
                className={activeSection === "schedule" ? "active" : ""}
              >
                SCHEDULE
              </button>
            </div>
          </div>

          {activeSection === "rules" && (
            <div id="rules_section">
              {game.game?.description && (
                <ReactMarkdown>{game.game?.description!}</ReactMarkdown>
              )}
            </div>
          )}

          {activeSection === "teams" && (
            <div id="teams_section">
              <h2> Team Creation Information </h2>
              <ol>
                <li>
                  Teams are to be formed to participate in tournaments that
                  require a team
                </li>
                <li> A team needs a team leader </li>
                <li>
                  A team leader is the player that forms the team and invites
                  teammates
                </li>
                <li>
                  A team is created when all players invited have accepted the
                  invitation to the team
                </li>
                <li>
                  Only the team lead can register the team into tournaments
                </li>
              </ol>

              <h2> Types of Matches in Teams </h2>
              <ol>
                <li>
                  Team Deathmatch - Team up to kill opposing team members and
                  earn points. The first team to the score limit points wins.
                </li>
                <li>
                  Domination - Capture objectives to earn a steady slew of
                  points. The first to reach the score limit wins.
                </li>
                <li>
                  Search and Destroy - Work in teams to destroy enemy
                  objectives. If you die, you will not respawn.
                </li>
              </ol>
            </div>
          )}

          {activeSection === "schedule" && (
            <div id="schedule_section">
              <div className="month">
                <ul>
                  <li className="prev">&#10094;</li>
                  <li className="next">&#10095;</li>
                  <li>
                    August
                    <br />
                    <span style={{ fontSize: "18px" }}>2021</span>
                  </li>
                </ul>
              </div>

              <ul className="weekdays">
                <li>Mo</li>
                <li>Tu</li>
                <li>We</li>
                <li>Th</li>
                <li>Fr</li>
                <li>Sa</li>
                <li>Su</li>
              </ul>

              <ul className="days">
                <li>1</li>
                <li>2</li>
                <li>3</li>
                <li>4</li>
                <li>5</li>
                <li>6</li>
                <li>7</li>
                <li>8</li>
                <li>9</li>
                <li>
                  <span className="active">10</span>
                </li>
                <li>11</li>
                <li>12</li>
                <li>13</li>
                <li>14</li>
                <li>15</li>
                <li>16</li>
                <li>17</li>
                <li>18</li>
                <li>19</li>
                <li>20</li>
                <li>21</li>
                <li>22</li>
                <li>23</li>
                <li>24</li>
                <li>25</li>
                <li>26</li>
                <li>27</li>
                <li>28</li>
                <li>29</li>
                <li>30</li>
                <li>31</li>
              </ul>
            </div>
          )}
        </>
      )}
    </IndividualGamePageWrapper>
  );
}

export default IndividualGamePage;
